import { render } from "./ViewJobs.vue?vue&type=template&id=8dcb0622&scoped=true"
import script from "./ViewJobs.vue?vue&type=script&lang=js"
export * from "./ViewJobs.vue?vue&type=script&lang=js"

import "./ViewJobs.vue?vue&type=style&index=0&id=8dcb0622&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dcb0622"]])

export default __exports__